import { HttpClient } from '@angular/common/http';
import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GcpService } from 'projects/gcp/src/public-api';
import { OpportunityService } from 'projects/opportunity/src/public-api';
import { OpportunityModel } from 'src/models/mongo/opportunity.model';
import { LocalStorageService } from 'src/servcies/localstorage-service';
import { Endpoint, Unicode } from 'src/shared/Endpoint';
import { Utilities } from 'src/shared/utilities';

@Component({
  selector: 'add-billing-account',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './add-billing-account.component.html',
  styleUrls: ['./add-billing-account.component.scss'],
})
export class AddBillingAccountComponent implements OnInit {
  @Input() createdBillingData: any = {};
  gcpSkus = [];
  mainBilling = [];
  gcpPlans = [];
  @Input('creatBillingModal') creatBillingModal: ModalDirective;
  @Output() additionalBillingAccountData = new EventEmitter<any>();
  offers = [];
  @Input() fullAction: boolean = false; // MEANS CREATE CUSTOMER AND ENTITLEMENT AT THE SAME TIME
  countries = [];
  @Input() pocID: string;
  @Input() opportunityID: string;
  opportunity: OpportunityModel;

  oppService = inject(OpportunityService);

  constructor(
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private gcpService: GcpService
  ) {
    effect(() => {
      this.opportunity = this.oppService.opportunity();
    });
  }

  async ngOnInit(): Promise<void> {
    var that = this;
    var globalData = await Utilities.globalData(this.http, this.localStorage);
    var gData = Utilities.getGlobalDataValues(globalData);
    this.countries = gData.countries;
    this.offers = await Utilities.offerList(this.http, this.localStorage); //todo use n backend only
    if (this.offers) {
      this.gcpSkus = this.offers.map((offer) => ({
        name: offer.sku,
        isSelected: false,
        logo: offer.logo,
      }));
      this.gcpSkus = Array.from(new Set(this.gcpSkus));
      this.gcpPlans = this.offers.map((offer) => ({
        name: offer.plan,
        isSelected: false,
        description: offer.description,
      }));
      this.gcpPlans = Array.from(new Set(this.gcpPlans));
    }

    this.createdBillingData.msp = this.opportunity?.msp ?? { is_msp: false };

    // await this.gcpService
    //   .getListOfBillingAccount(true, null, null, null, null)
    //   .then((resp: any) => {
    //     this.mainBilling = resp.data ?? [];
    //   });
  }

  async saveBillingAccount() {
    var that = this;
    var sku = this.gcpSkus.find((sku) => sku.isSelected)?.name;
    var plan = this.gcpPlans.find((plan) => plan.isSelected)?.name;
    if (Utilities.isNullOrEmpty(sku) || Utilities.isNullOrEmpty(plan)) {
      alert('Select SKU and Plan');
      return;
    }
    var id = this.offers.find((x) => x.sku == sku && x.plan == plan)?.id;
    if (
      id &&
      !Utilities.isNullOrEmpty(this.createdBillingData.billingAccountName)
    ) {
      if (this.fullAction == true) {
        var model;
        var cstjson = this.localStorage.get(Unicode.CURRENT_CUSTOMER);
        if (!Utilities.isNullOrEmpty(cstjson)) model = JSON.parse(cstjson);
        if (model) {
          var body: any = {
            billing_account_name: this.createdBillingData.billingAccountName,
            id: id,
            domain: model,
            domain_rfid: model._id,
            poc_id: this.pocID,
            sku: sku,
            plan: plan,
            parent: this.createdBillingData.mainBillingAccount?.name
              ? this.createdBillingData.mainBillingAccount.name.split('/')[1]
              : null,
            opportunity_rfid: this.opportunityID,
            credit_amount: this.createdBillingData.amount,
            is_msp: this.createdBillingData.msp?.is_msp ?? false,
          };
          const formData = new FormData();
          if (this.createdBillingData.msp?.file)
            formData.append(
              Unicode.MSP_ATTACHED_FILE,
              this.createdBillingData.msp.file
            );
          formData.append(Unicode.DATA, JSON.stringify(body));
          await this.http
            .post(
              Endpoint.API_URL + Endpoint.CREATE_FULL_GCP_SERVICE,
              formData
            )
            .toPromise()
            .then((channelEntitlementsResult: any) => {
              if (
                channelEntitlementsResult?.success == true &&
                channelEntitlementsResult?.rfid
              ) {
                var billingAccountRfid = channelEntitlementsResult.rfid;
                body.billing_account_rfid = billingAccountRfid;
                //this.creatBillingModal.hide();
                this.additionalBillingAccountData.emit(body);
              }
            });
        }
      } else {
        if (!Utilities.isNullOrEmpty(this.createdBillingData.channelName)) {
          this.createdBillingData = {
            ...this.createdBillingData,
            selectedSku: sku,
            selectedPaymentPlan: plan,
          };
          var bodyy = {
            customer_channel_name: this.createdBillingData.channelName,
            billing_account_name: this.createdBillingData.billingAccountName,
            id: id,
            credit_amount: this.createdBillingData.amount,
            opportunity_rfid: this.opportunityID,
            is_msp: this.createdBillingData.msp?.is_msp ?? false,
          };
          const formData = new FormData();
          if (this.createdBillingData.msp?.file)
            formData.append(
              Unicode.MSP_ATTACHED_FILE,
              this.createdBillingData.msp.file
            );
          formData.append(Unicode.DATA, JSON.stringify(bodyy));
          await this.http
            .post(
              Endpoint.API_URL + Endpoint.CREATE_Entitlement_BILLING_ACCOUNT,
              formData
            )
            .toPromise()
            .then((channelEntitlementsResult: any) => {
              if (channelEntitlementsResult?.success == true) {
                // this.creatBillingModal.hide();
                this.additionalBillingAccountData.emit(this.createdBillingData);
              }
            });
        } else {
          alert('Missing Info');
        }
      }
    } else alert('Add Billing Account Name!!');
  }

  mspDataUpdated(data) {
    if (null !== data?.is_msp && undefined !== data?.is_msp)
      this.createdBillingData.msp.is_msp = data.is_msp;
    if (null !== data?.file && undefined !== data?.file) {
      this.createdBillingData.msp.file = data.file;
      this.createdBillingData.msp.attachment_proof_name =
        data.attachment_proof_name;
    }
  }
}
